import React, { FC, useCallback } from "react";

import { Modal, Stack } from "react-bootstrap";

import { useGetPresignedDownloadUrlMutation } from "@api/graphql";
import { documentKeyFromS3Location } from "@util/index";

import styles from "./BatchDownloadModal.module.scss";

export interface File {
  id: string;
  name: string;
  s3Location: string;
}

interface BatchDownloadModalProps {
  files: File[];
  show: boolean;
  onHide: () => void;
}

export const BatchDownloadModal: FC<BatchDownloadModalProps> = ({ files, show, onHide }) => {
  const [getPresignedDownloadUrl] = useGetPresignedDownloadUrlMutation();

  const handleDownload = useCallback(
    async (s3Location: string) => {
      try {
        const key = documentKeyFromS3Location(s3Location);
        const { data } = await getPresignedDownloadUrl({
          variables: { documentKey: key },
        });
        const downloadUrl = data?.getPresignedDownloadURL?.downloadUrl;
        if (downloadUrl) {
          window.open(downloadUrl, "_blank");
        }
      } catch (error) {
        console.error("Failed to get download URL:", error);
      }
    },
    [getPresignedDownloadUrl],
  );

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Download Files</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stack direction="vertical" gap={3}>
          {files.map((file) => (
            <div key={file.id} onClick={() => handleDownload(file.s3Location)} className={styles["download-link"]}>
              <span className="b3 bold">{file.name}</span>
            </div>
          ))}
        </Stack>
      </Modal.Body>
    </Modal>
  );
};
